import Homepage from "./pages/Homepage";
function App() {
  return (
    <div>
     <Homepage/>
    </div>
  );
}

export default App;
